/**
 * Configuration par défaut du widget
 */

/**
 * Détecte automatiquement la baseUrl selon l'environnement
 */
function detectBaseUrl() {
  // Toujours utiliser ringado.com comme baseUrl par défaut
  // Cela évite les erreurs 405 en développement local
  return 'https://ringado.com';
}

export const DEFAULT_CONFIG = {
  operatorId: null,
  userId: null,
  targetOperatorId: null,
  baseUrl: null, // Sera détecté automatiquement dans le constructeur du widget
  position: 'bottom-right',
  theme: 'light',
  requireEmail: false,
  isPro: undefined,
  clientName: null,
  initiallyVisible: true,
  autoOpen: false,
  debug: false,
  customStyles: {},
  callbacks: {
    onReady: null,
    onChatOpen: null,
    onChatClose: null,
    onMessageSent: null,
    onMessageReceived: null,
    onError: null,
  },
};
